/**
 * Haptic Feedback Utilities
 * Provides tactile feedback for user interactions (when supported)
 */

export const hapticFeedback = (type = 'light') => {
  if ('vibrate' in navigator) {
    const patterns = {
      light: [10],
      medium: [20],
      heavy: [30],
      success: [10, 50, 10],
      error: [20, 40, 20, 40],
      warning: [15, 30, 15],
    };
    
    navigator.vibrate(patterns[type] || patterns.light);
  }
};

export const haptics = {
  light: () => hapticFeedback('light'),
  medium: () => hapticFeedback('medium'),
  heavy: () => hapticFeedback('heavy'),
  success: () => hapticFeedback('success'),
  error: () => hapticFeedback('error'),
  warning: () => hapticFeedback('warning'),
};
